module.exports = __webpack_public_path__ + "static/media/pokebola.e71defd8.png";